<template>
  <div v-if="sdkIntialized">
    <div class="blockUI" style="display:none"></div>
    <div class="blockUI blockOverlay"
         style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
    <div class="blockUI blockMsg blockPage"
         style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
      <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait while you request is being processed...</p>
        <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
      </div>
    </div>
  </div>
  <div class="app-content content " v-if="!sdkIntialized">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" style="max-width: 80%;"
                                                                                               :src="`${publicPath}app-assets/images/pages/3d.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-white cursiveFont">3D Secure Payments!</h3>
                <h3 class="text-white cursiveFont">Pay With Peace Of Mind.</h3>
                <p class="text-white mb-0 ">Built On Latest Block Chain Technology</p>
                <p class="text-white mb-0 ">Online credit/ debit card payments support</p>
                <p class="text-white mb-0 ">End to end payment management</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Login With Passcode!</h3>
                <p class="card-text mb-2">For extended security, your passcode is required</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" :validation-schema="schema">
                  <div class="form-group">
                    <label class="form-label">Passcode</label>
                    <Field name="passcode" class="form-control" type="password" placeholder="Passcode" v-model="passcode"/>
                    <ErrorMessage name="passcode" class="text-danger" />
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Submit</Button>
                  </div>
                </form>
                <p class="text-center mt-2"><span>Want to reset pin?</span><a @click="goToResetPasscode" href="javascript:void(0)"><span>&nbsp;Reset Pin</span></a></p>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import snsWebSdk from "@sumsub/websdk";

export default {
  mounted() {
    // if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
    //   // page is reloaded
    //   this.redirectToLogin()
    // }

    this.requestPermission().then(response => {
      this.fcmToken = response
    })
  },
  data() {
    return {
      loader: false,
      passcode: '',
      fcmToken: null,
      sdkIntialized:false,


    }
  },
  methods: {
    redirectToLogin(){
        let r = this.$router.resolve({
          name: 'login', // put your route information in
          // params: this.$route.params, // put your route information in
          // query: this.$route.query // put your route information in
        });
        window.location.assign(r.href)


    },
    goToResetPasscode() {
      this.$store.commit("setResetType", 2)
      this.$router.push({name: 'verify-email-general'});
    },
    sendCall() {

      let data = {
        "passcode": this.passcode,
        "deviceToken": this.fcmToken,
      }
      this.loader = true
      this.makeRequest('post', 'v1/passcode-login', data).then(callResponse => {

        this.loader = false

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$store.commit('setLoggedInUser', callResponse.response.data.data);
            localStorage.removeItem('email');
            if(callResponse.response.data.data.avatar){
              this.$store.dispatch('updateUserProfilePicture',callResponse.response.data.data.avatar)
            }

            if(callResponse.response.data.data.sumsubToken){

              window.onpopstate = () => {
                this.redirectToLogin()
              };
              this.launchWebSdk(callResponse.response.data.data.sumsubUrl,callResponse.response.data.data.kycFlow,callResponse.response.data.data.sumsubToken,'passcode-login')
            }else{
              var newUrl = window.location.href.replace('auth/passcode-login','app/');

              window.location.href = newUrl
            }




          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    // launchWebSdk(apiUrl, flowName, accessToken,successRouteFrom, applicantEmail, applicantPhone, customI18nMessages) {
    //   this.sdkIntialized = true
    //   let snsWebSdkInstance = snsWebSdk.Builder(apiUrl, flowName)
    //       .withAccessToken(
    //           accessToken,
    //           (newAccessTokenCallback) => {
    //             // Access token expired
    //             // get a new one and pass it to the callback to re-initiate the WebSDK
    //             let newAccessToken = newAccessToken(); // get a new token from your backend
    //             newAccessTokenCallback(newAccessToken)
    //           }
    //       )
    //       .withConf({
    //         lang: 'en', //languge of WebSDK texts and comments (ISO 639-1 format)
    //         email: applicantEmail,
    //         phone: applicantPhone,
    //         i18n: customI18nMessages,
    //         onMessage: (type, payload) => {
    //           this.sdkIntialized = false
    //           document.querySelector("#app").style["display"] = 'none'
    //           // see below what kind of messages the WebSDK generates
    //           // console.log('WebSDK onMessage', type, payload)
    //           if(type == 'idCheck.onApplicantSubmitted'){
    //             if(successRouteFrom == 'passcode-login'){
    //               var newUrl = window.location.href.replace('auth/passcode-login','app/');
    //               window.location.href = newUrl
    //             }else if(successRouteFrom == 'set-passcode'){
    //               var newUrl = window.location.href.replace('auth/set-passcode','auth/passcode-login');
    //               window.location.href = newUrl
    //             }
    //           }
    //         },
    //         uiConf: {
    //           customCss: "https://url.com/styles.css"
    //           // URL to css file in case you need change it dynamically from the code
    //           // the similar setting at Applicant flow will rewrite customCss
    //           // you may also use to pass string with plain styles `customCssStr:`
    //         },
    //         onError: (error) => {
    //           this.sdkIntialized = false
    //           console.error('WebSDK onError', error)
    //         },
    //       })
    //       .build();
    //
    //   // you are ready to go:
    //   // just launch the WebSDK by providing the container element for it
    //   snsWebSdkInstance.launch('#sumsub-websdk-container')
    // },
  },
}
</script>

